import { Terminal as XTerminal } from "@xterm/xterm";
import { FitAddon } from "@xterm/addon-fit";
import { Remote } from "comlink";

import { BaseTerminal } from "./terminal";
// import IdleListener from "./idle-listener";
import { VM } from "./vm";

// xterm theme
import "@xterm/xterm/css/xterm.css";
import molokai from "./molokai";
import "./main.css";

class WebTerminal extends BaseTerminal {
  private _elem: HTMLElement;
  private _term: XTerminal;

  constructor(selector: string) {
    super();
    this._elem = document.querySelector(selector)!;
    if (this._elem == null) throw new Error(`'${selector}' not found in DOM`);

    // create xterm
    this._term = new XTerminal({
      theme: molokai,
      fontSize: 20,
      fontFamily: "monospace",
    });

    // fit terminal size
    const fitAddon = new FitAddon();
    this._term.loadAddon(fitAddon);
    this._term.open(this._elem);
    fitAddon.fit();
    window.addEventListener("resize", () => fitAddon.fit(), false);
  }

  public setVM(vm: VM | Remote<VM>) {
    this._term.onData(async (data: string) => {
      await vm.sendSerialInput("user", data);
    });

    // const idleListener = new IdleListener({
    //   timeout: 10000,
    //   idleCallback: () => vm.pause(),
    //   resumeCallback: () => vm.play(),
    // });
    // this._term.onKey(() => idleListener.reset());
  }

  public focus() {
    this._term.focus();
  }

  public write(data: string) {
    this._term.write(data);
  }

  public writeln(data: string) {
    this._term.writeln(data);
  }
}

export { WebTerminal };
